import { ConnectResourceType } from '../api/api-entities';

export interface ConnectResourceValue {
  connect_resource: {
    name: string;
    arn: string;
    type: ConnectResourceType;
  };
}

export interface LegacyConnectResourceValue {
  resourceName: string;
  resourceArn: string;
}

export function isConnectResourceValue(value: unknown): value is ConnectResourceValue {
  return (
    typeof value === 'object' &&
    value !== null &&
    'connect_resource' in value &&
    typeof (value as ConnectResourceValue).connect_resource === 'object' &&
    (value as ConnectResourceValue).connect_resource !== null
  );
}

export function isLegacyConnectResourceValue(value: unknown): value is LegacyConnectResourceValue {
  return (
    typeof value === 'object' &&
    value !== null &&
    'resourceName' in value &&
    'resourceArn' in value &&
    !('connect_resource' in value)
  );
}

export function normalizeConnectResource(
  value: unknown,
  resourceType: ConnectResourceType
): ConnectResourceValue | null {
  if (!value) {
    return null;
  }

  if (isConnectResourceValue(value)) {
    return value;
  }

  if (isLegacyConnectResourceValue(value)) {
    return {
      connect_resource: {
        name: value.resourceName,
        arn: value.resourceArn,
        type: resourceType
      }
    };
  }

  return null;
}

export function getDisplayName(value: ConnectResourceValue | LegacyConnectResourceValue | null | undefined): string {
  if (!value) {
    return '';
  }

  if (isConnectResourceValue(value)) {
    return value.connect_resource.name;
  }

  if (isLegacyConnectResourceValue(value)) {
    return value.resourceName;
  }

  return '';
}

export function getArn(value: ConnectResourceValue | LegacyConnectResourceValue | null | undefined): string {
  if (!value) {
    return '';
  }

  if (isConnectResourceValue(value)) {
    return value.connect_resource.arn;
  }

  if (isLegacyConnectResourceValue(value)) {
    return value.resourceArn;
  }

  return '';
}
